import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ParagraphNodeView from './ParagraphNodeView';

/**
 * Custom Paragraph Extension with Notion-style hover controls
 * 
 * This extension wraps each paragraph with a React component that provides:
 * - A drag handle on hover
 * - An action menu with "Add to Vault" and "Add to Mariko" buttons
 */
const ParagraphWithControls = Node.create({
    name: 'paragraph',

    priority: 1000,

    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },

    group: 'block',
    content: 'inline*',

    parseHTML() {
        return [
            { tag: 'p' },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['p', HTMLAttributes, 0];
    },

    addNodeView() {
        return ReactNodeViewRenderer(ParagraphNodeView);
    },
});

export default ParagraphWithControls;
